'use strict';

var _ = require('lodash');
var MarketAnalysisDemandAdjustmentController = function MarketAnalysisDemandAdjustmentController($scope) {
  $scope.VIEWS = [{
    label: 'Time of Day',
    value: 'demand-adjustment-time-of-day',
    disabled: false,
    isMultipleRowsSelectionSupported: true
  }, {
    label: 'Fare',
    value: 'demand-adjustment-fare',
    disabled: false,
    isMultipleRowsSelectionSupported: false
  }, {
    label: '# of Stops',
    value: 'demand-adjustment-number-of-stops',
    disabled: false,
    isMultipleRowsSelectionSupported: false
  }];
  $scope.areMultipleRowsSelected = $scope.selectedRows.length > 1;
  $scope.filterViews = function (views, areMultipleRowsSelected) {
    return _.filter(views, function (view) {
      return areMultipleRowsSelected && view.isMultipleRowsSelectionSupported || !areMultipleRowsSelected;
    });
  };
  $scope.views = $scope.filterViews($scope.VIEWS, $scope.areMultipleRowsSelected);
  $scope.chartInCompareMode = null;
  $scope.selected = {
    chart: $scope.VIEWS[0].value
  };
  $scope.isSet = function (tabName) {
    return $scope.selected.chart === tabName;
  };
  $scope.getView = function (tabName) {
    return _.find($scope.views, ['value', tabName]);
  };
};
MarketAnalysisDemandAdjustmentController.$inject = ['$scope'];
module.exports = MarketAnalysisDemandAdjustmentController;